import { Box, Divider, Dropdown, FormField, ListItemSelect } from "@wix/design-system";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useBiNext } from "./../../../bi-context-provider/bi-context-provider.js";
import { LINK_MODAL_ID } from "./../../../link-modal/constants.js";
import { dataHook } from "./../../../../wix-rich-content-common/index.js";
import { SECTION_SELECT, SECTION_TYPE_SELECT } from "../../data-hooks/data-hooks.js";
import { SectionEmptyState } from "./empty-state.js";
import { useSectionOptions } from "./use-options.js";
const selectedListItem = "selected-list-item";
const SectionMobile = ({ link, onSelect, t }) => {
  const logBi = useBiNext({ pluginId: "link", modalId: LINK_MODAL_ID });
  const { sections, sectionTypeOptions } = useSectionOptions();
  const itemContainerRef = useRef();
  const [selectedTypeOption, setSelectedTypeOption] = useState(
    sectionTypeOptions[0]
  );
  const filteredSections = useMemo(
    () => sections.filter(
      (section) => selectedTypeOption.id === "all" || section.node.type === selectedTypeOption.id
    ),
    [sections, selectedTypeOption]
  );
  useEffect(() => {
    setTimeout(() => {
      itemContainerRef.current?.querySelector(dataHook(selectedListItem))?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }, []);
  if (sections.length === 0) {
    return /* @__PURE__ */ React.createElement(SectionEmptyState, { t });
  }
  const onSelectType = (option) => {
    setSelectedTypeOption(option);
    logBi({ dataHook: SECTION_TYPE_SELECT, value: `${option.id}` });
  };
  const onSelectSection = (section) => {
    onSelect(section.id, section.title);
    logBi({ dataHook: SECTION_SELECT });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { direction: "vertical", paddingLeft: "SP3", paddingRight: "SP3" }, /* @__PURE__ */ React.createElement(FormField, { label: t("LinkSettings_Sections_TypeDropdown_Label"), labelPlacement: "top" }, /* @__PURE__ */ React.createElement(
    Dropdown,
    {
      dataHook: SECTION_TYPE_SELECT,
      onSelect: onSelectType,
      options: sectionTypeOptions,
      selectedId: selectedTypeOption.id,
      size: "small",
      valueParser: (option) => option.label
    }
  ))), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(
    Box,
    {
      direction: "vertical",
      flexGrow: 1,
      overflowY: "auto",
      padding: 0,
      paddingBottom: "SP3",
      ref: itemContainerRef
    },
    filteredSections.map((section) => {
      const selected = section.id === link.anchor;
      return /* @__PURE__ */ React.createElement(
        ListItemSelect,
        {
          dataHook: selected ? selectedListItem : void 0,
          ellipsis: true,
          titleMaxLines: 2,
          highlighted: selected,
          key: section.id,
          onClick: () => onSelectSection(section),
          prefix: section.prefixAvatar,
          selected,
          size: "medium",
          subtitle: section.subtitle,
          title: section.title
        }
      );
    })
  ));
};
export {
  SectionMobile
};
//# sourceMappingURL=section-mobile.js.map
